import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql, Link } from 'gatsby'
import styled from 'styled-components'

import Categories from '../Categories'

const ContentPost = styled.div`
  align-items: center;
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
`

const SideBar = ({ list }) => {
  const data = useStaticQuery(graphql`
    query lastPosts {
      allContentfulPost(limit: 4,
        filter: {type: {nin: "entry"}})  {
        edges {
          node {
            slug
            title
            createdAt(formatString: "MMM DD, YYYY")
            image {
              file {
                url
                fileName
              }
            }
          }
        }
      }
    }
  `)

  const { edges: posts } = data.allContentfulPost

  return (
    <div id='firo-sidebar' className='firo-sidebar'>
      {!list &&
        <div className='nile-widget layout-1 firo_latest_news_widget'>
          <div className='title text-main-color'>Latest Posts</div>
          {
            posts.map(({ node }, index) => {
              const { title, slug, image, createdAt } = node
              return (
                <ContentPost key={index} className='post row'>
                  <div className='col-lg-3'><Link to={`/post/${slug}`}><img src={image.file.url} alt={image.file.fileName} /></Link></div>
                  <div className='col-lg-9'>
                    <div className='date'><span className='icon_clock_alt' />{createdAt}</div>
                    <Link to={`/post/${slug}`} className='title'>{title}</Link>
                  </div>
                </ContentPost>
              )
            })
          }
        </div>}
      <Categories />
    </div>
  )
}

SideBar.propTypes = {
  list: PropTypes.bool,
  type: PropTypes.string
}

SideBar.defaultProps = {
  list: false,
  type: ''
}

export default SideBar
